/**
 * Relay for Track Page
 */

import { graphql as gql } from 'react-relay';
const graphql = gql;

export const TrackPageQuery = graphql`
  query track_Query($id: Int, $slug: String, $license_params: [LicenseUsageParamsInput], $currency: Currency) {
    track(id: $id, slug: $slug, license_params: $license_params, currency: $currency) {
      ...trackFragment_track
    }
  }
`;

export const TrackFragment = graphql`
  fragment trackFragment_track on TrackSearchResult {
    ...trackNode @relay(mask: false)
  }
`;

export const trackNode = graphql`
  fragment trackNode on TrackSearchResult {
    id
    internal_id
    price
    base_price
    title
    added_to_cart
    slug
    duration
    score
    boosted_score
    stems_available
    customizable
    matched_exclusions
    tempos{
      ...tempoNode @relay(mask: false)
    }
    assets{
      ...assetNode @relay(mask: false)
    }
    artist{
      ...artistNode @relay(mask: false)
    }
    terms(first: 100){
      edges{
        node{
          ...termNode @relay(mask: false)
        }
      }
    }
    collections{
      edges{
        node{
          ...collectionNode @relay(mask: false)
        }
      }
    }
    association_id
    selected_version
  }
`;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/relay/track.ts